module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_second.f17bfa7e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_second.png
// module id = 1387
// module chunks = 11